/**
 * Created by chris on 12/04/2016.
 */
import Rellax from 'rellax'
import 'youtube-background'



jQuery(document).ready(function($){


	// var videoBackground = new VideoBackgrounds('[data-vbg]');

	// seperate for homepage video
	jQuery('[data-vbg]').youtube_background({
		'fit-box': true,
		'inline-styles': false,
	});

	var rellax = new Rellax('.rellax', {
		breakpoints:[576, 800, 1201]
	  });
	
//	STICKY HEADER START
// When the user scrolls the page, execute myFunction
	window.onscroll = function() {myFunction()};
// Get the header
	var header = document.getElementById("header");
	var stateSelector = document.getElementById("state-selector");
// Get the offset position of the navbar
	var sticky = header.offsetTop;
	console.log(sticky);
// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
	function myFunction() {
		if (window.pageYOffset > sticky) {
			header.classList.add("sticky");
			stateSelector.classList.add("sticky");
		} else {
			header.classList.remove("sticky");
			stateSelector.classList.remove("sticky");
		}
	}
//	STICKY HEADER END

	//mobile menu open sub menu
	$('.mobile-menu-holder .menu-item-has-children').on('click', function(e){
		if(e.target.href === undefined){
			e.preventDefault();
			console.log(e)
			//if the target has the class "open", slide up and remove the class
			if($(this).hasClass('open')){
				$(this).children('ul').slideUp();
				$(this).removeClass('open');
			}else{
				//if the target does not have the class "open", slide down and add the class
				$(this).children('ul').slideDown();
				$(this).addClass('open');
			}
			// $(this).toggleClass('open');
		}
	});

	$('.hamburger-holder').on('click', function(){
		$(this).toggleClass('open');
		$('.mobile-menu-holder').toggleClass('open');
	});

	// add responsive class to spacers
	$('.wp-block-spacer').each(function(){
		var height = $(this).height();
		$(this).addClass('responsive-spacer-'+height);
	})

	if(document.querySelectorAll('.wp-block-embed__wrapper').length > 0) {
		const players = Plyr.setup('.wp-block-embed__wrapper');
	}


	var x, i, j, l, ll, selElmnt, a, b, c;
	/* Look for any elements with the class "custom-select": */
	x = document.getElementsByClassName("custom-select");
	l = x.length;
	for (i = 0; i < l; i++) {
		selElmnt = x[i].getElementsByTagName("select")[0];
		ll = selElmnt.length;
		/* For each element, create a new DIV that will act as the selected item: */
		a = document.createElement("DIV");
		a.setAttribute("class", "select-selected");
		a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
		x[i].appendChild(a);
		/* For each element, create a new DIV that will contain the option list: */
		b = document.createElement("DIV");
		b.setAttribute("class", "select-items select-hide");
		for (j = 1; j < ll; j++) {
			/* For each option in the original select element,
            create a new DIV that will act as an option item: */
			c = document.createElement("DIV");
			c.innerHTML = selElmnt.options[j].innerHTML;
			c.addEventListener("click", function(e) {
				/* When an item is clicked, update the original select box,
                and the selected item: */
				var y, i, k, s, h, sl, yl;
				s = this.parentNode.parentNode.getElementsByTagName("select")[0];
				sl = s.length;
				h = this.parentNode.previousSibling;
				for (i = 0; i < sl; i++) {
					if (s.options[i].innerHTML == this.innerHTML) {
						s.selectedIndex = i;
						h.innerHTML = this.innerHTML;
						y = this.parentNode.getElementsByClassName("same-as-selected");
						yl = y.length;
						for (k = 0; k < yl; k++) {
							y[k].removeAttribute("class");
						}
						this.setAttribute("class", "same-as-selected");
						break;
					}
				}
				h.click();
			});
			b.appendChild(c);
		}
		x[i].appendChild(b);
		a.addEventListener("click", function(e) {
			/* When the select box is clicked, close any other select boxes,
            and open/close the current select box: */
			e.stopPropagation();
			closeAllSelect(this);
			this.nextSibling.classList.toggle("select-hide");
			this.classList.toggle("select-arrow-active");
		});
	}

	function closeAllSelect(elmnt) {
		/* A function that will close all select boxes in the document,
        except the current select box: */
		var x, y, i, xl, yl, arrNo = [];
		x = document.getElementsByClassName("select-items");
		y = document.getElementsByClassName("select-selected");
		xl = x.length;
		yl = y.length;
		for (i = 0; i < yl; i++) {
			if (elmnt == y[i]) {
				arrNo.push(i)
			} else {
				y[i].classList.remove("select-arrow-active");
			}
		}
		for (i = 0; i < xl; i++) {
			if (arrNo.indexOf(i)) {
				x[i].classList.add("select-hide");
			}
		}
	}

	/* If the user clicks anywhere outside the select box,
    then close all select boxes: */
	document.addEventListener("click", closeAllSelect);
})

jQuery(window).load(function($){

})

jQuery(window).resize(function($){
	halfspacerheightonmobile();
})

function sizetorow(divheight, target, adjustment){
	var $ = jQuery;
	if($(window).width() > 800){
		var maxHeight = 0;

		$(target).css('min-height',maxHeight);
		var maxHeight = $(divheight).height() - adjustment;
		console.log(maxHeight);
		//$(target).each(function(){
		//
		//})
		setTimeout(function(){
			$(target).css('min-height',maxHeight);
		},600)
	}
}

function makesquare(target){
	var $ = jQuery;
	var width = $(target).width();
	$(target).height(width);
}

